import React, { useEffect, useState } from 'react';
import { cn } from '@/utils/cn';
import CampaignSectionHeader from '@/app/components/Header/CampaignSectionHeader';
import Slider from '@/app/components/Slider';
import { contentsAPIV2 } from '@/utils/contentsApi';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import { screenTypes } from '@/constants/types';
import SectionCTA from '../Header/SectionCTA';

function CampaignProductCarousel({
  section,
  hasParentBG,
  isInvisibleBgColor,
  hasParentTimer,
}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [exploreImageData, setExploreImageData] = useState([]);
  const [targetEndDate, setTargetEndDate] = useState(
    new Date(section?.details?.timer_end_to),
  );
  const windowDimensions = useWindowDimensions();

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPIV2(contentsData);
        setData([...response.items]);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        console.warn('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (section?.details?.timer_end_to) {
      const targetDate = section.details.timer_end_to;
      const parsedDate = new Date(targetDate);

      if (!Number(parsedDate)) {
        setTargetEndDate(parsedDate);
      }
    }

    const exploreImage = section?.explore_image;
    if (exploreImage?.large) {
      setExploreImageData(exploreImage);
    }
  }, [section]);

  useEffect(() => {
    const exploreImage = section?.explore_image;

    if (exploreImage?.large) {
      setExploreImageData(exploreImage);
    }
  }, [section]);

  const currentDate = new Date();

  const isFutureStart =
    new Date(section?.details?.timer_start_from) > currentDate;

  const isExpired =
    targetEndDate && currentDate > new Date(section?.details?.timer_end_to);

  if (isExpired || isFutureStart) {
    return null;
  }

  if (Array.isArray(data) && data?.length === 0) {
    return null;
  }

  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  return (
    <section
      className={cn(
        'campaign-product-carousel pb-28 mb-24 lg:mb-48',
        !hasParentBG && !isInvisibleBgColor && section?.has_background
          ? 'has-background'
          : '',
      )}
      style={{
        '--gradient-color-1':
          section?.details?.gradient_color_1 || 'transparent',
        '--gradient-color-2':
          section?.details?.gradient_color_2 || 'transparent',
      }}
    >
      <div className="container mx-auto">
        <CampaignSectionHeader
          uiComponentName={section?.ui_component_name}
          sectionId={section?.id}
          sectionContentType={section?.content_type}
          sectionTitle={section?.title?.en}
          sectionRedirectUrl={section?.redirect_url}
          title={section?.title?.en}
          // buttonTitle={sectionGroupItems?.redirect_url?.en?.text ?? ''}
          hideButton={windowDimensions?.width < screenTypes.large}
          targetStartDate={section?.details?.timer_start_from}
          targetEndDate={section?.details?.timer_end_to}
          topIcon={section?.has_icon ? section?.details?.icon : false}
          showCountDownTimer={hasParentTimer ? false : section?.has_timer}
          showForFlashSale="true"
        />
      </div>
      <Slider
        type="flash-sale-slider"
        items={data}
        isLoading={isLoading}
        sectionId={section?.id}
        sectionContentType={section?.content_type}
        showProductLastCard={exploreImageData}
        sectionRedirectUrl={section?.redirect_url}
      />
      <SectionCTA
        sectionId={section?.id}
        sectionContentType={section?.content_type}
        title={section?.title?.en}
        sectionRedirectUrl={section?.redirect_url}
        buttonOnly="true"
        className="flex lg:hidden mt-12 lg:mt-0"
      />
    </section>
  );
}

export default CampaignProductCarousel;
